import { useState } from "react";
//import { Video } from "../types/video";
import VideoCard from "./VideoCard";
import VideoModal from "./VideoModal";
import { ShortsVideo } from "types/event";

interface Props {
  video: ShortsVideo;
  runningVideo: any
  setRunningVideo: any
}

export default function VideoSlsider({ video, runningVideo, setRunningVideo }: Props) {
  const [selectedVideo, setSelectedVideo] = useState<ShortsVideo | null>(null);


  return (
    <>

      <div className="flex overflow-x-auto  keen-slider__slide">
        <VideoCard
          runningVideo={runningVideo}
          setRunningVideo={() => setRunningVideo(video)}
          key={video._id}
          video={video}
          onClick={() => setSelectedVideo(video)}
        />
      </div>
      {selectedVideo && (
        <VideoModal
          video={selectedVideo}
          onClose={() => setSelectedVideo(null)}
        />

      )}
    </>
  );
}
